import { createAction } from '@gef-ui/utils/fsaActions';
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { fieldStateActions } from '../../constants';
import { composeAction } from '../../utils';
/**
 * Update field state for given form.
 *
 * @documented
 * @category Action
 * @example
 *
 * 	updateFieldState('form')({ foo: 'bar' })
 *
 */ export const updateFieldState = memoizeWithIdentity((formName)=>createAction(composeAction(formName, fieldStateActions.UPDATE_FIELDS_STATE)));
/**
 * Set all fields valid
 *
 * @documented
 * @category Action
 * @example
 *
 * 	updateFieldState('form')
 *
 */ export const setAllFieldsValid = memoizeWithIdentity((formName)=>createAction(composeAction(formName, fieldStateActions.SET_ALL_FIELDS_VALID)));
